/*
 * @Author: liuxw@codoon.com
 * @Date: 2022-03-25 15:53:48
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2022-03-25 16:07:48
 */

import { isInCodoon } from "../../utils/bridge";

/**
 * 临时需求
 * 迪卡侬
 * 站内跳转到微信小程序的链接
 * 站外希望也能用，需要替换成 weixin://
 */

/* 站内、站外 链接用的 映射关系 */
export interface IUrlPair {
  inside: string; // 站内配置的链接
  outside: string; // 对应到站外时，需转换为
}

/* arr 转 map */
const urlPairsToMap = (pairs: IUrlPair[]) => {
  const obj: Record<string, string> = {};
  pairs.forEach((pair) => {
    obj[pair.inside] = pair.outside;
  });
  return obj;
};

/**
 * 【能拿到跳转url时，用的映射表】
 * 例如，代码能获取到跳转链接就是 detail.url
 * 那站外就用 JUMP_URL_MAP[detail.url]
 */
export const JUMP_URL_PAIRS: IUrlPair[] = [
  {
    inside:
      "https://www.codoon.com/weixinminiprogram?username=gh_e570578a0407&path=pages%2Fcoupon%2Fpages%2Flanding%2Flanding%3Fcampaign_id%3D39c16ebd29934e4f82996168fa4839e1%26utm_source%3Dgudong%26utm_medium%3Dbanner%26utm_campaign%3Dspring-campaign-2022-coupon",
    outside: "weixin://dl/business/?t=4r2mQzqQFgq",
  },
];
export const JUMP_URL_MAP = urlPairsToMap(JUMP_URL_PAIRS);

/* 封一个跳转函数，站外转成站外 */
export const jumpToUrlPair = (insideUrl: string) => {
  let jumpUrl = insideUrl;
  const outsideUrl = JUMP_URL_MAP[insideUrl];
  if (!isInCodoon() && outsideUrl) {
    // 站外，且有对应的转换url
    jumpUrl = outsideUrl;
  }
  window.location.href = jumpUrl;
};

/**
 * 【html 中，href 跳转用的映射表】
 * 因为 活动介绍、活动规则 是富文本编辑器配置的，跳转链接包含在html代码的href中
 * 跳转时，我们代码拿不到跳转url
 * 此时会遍历这个数组，然后用 replaceAll(urlPair.inside, urlPair.outside) 转换
 */
export const HTML_URL_PAIRS: IUrlPair[] = [
  {
    inside:
      "https://www.codoon.com/weixinminiprogram?username=gh_e570578a0407&amp;path=pages%2Fdcl_before_order%2FgoodList%2FgoodList.html%3Fcategory_link%3DN-87u3bv%26chan_id%3D29",
    outside: "weixin://dl/business/?t=uMtx4Y1GXBa",
  },
];
